import FilterAlertedFlightsToggle from './FilterAlertedFlightsToggle';

export default FilterAlertedFlightsToggle;
